<div class="text-center" *ngIf="loading">
  <div class="container-fluid container-shadow py-3 px-2">
    <i class="fas fa-spinner fa-pulse fa-3x"></i>
  </div>
</div>
<div *ngIf="!loading">
  <div class="container-fluid container-shadow py-3 px-2">
    <div class="row">
      <div class="col-12 text-center"><h4>FINANCIALS</h4></div>
    </div>
    <div class="my-3"></div>
    <div class="row">
      <div class="col-3 text-center"><h5>Escrow Fee</h5></div>
      <div class="col-3 text-center"><h5>Escrow Cost</h5></div>
      <div class="col-3 text-center"><h5>Escrow Other</h5></div>
      <div class="col-3 text-center"><h5>Escrow Total</h5></div>
    </div>
    <div class="row">
      <div class="col-3 text-center">{{ constructedInfo.escrow_fee | currency: 'USD':'symbol-narrow':'1.2-2' }}</div>
      <div class="col-3 text-center">{{ constructedInfo.escrow_cost | currency: 'USD':'symbol-narrow':'1.2-2' }}</div>
      <div class="col-3 text-center">{{ constructedInfo.escrow_other | currency: 'USD':'symbol-narrow':'1.2-2' }}</div>
      <div class="col-3 text-center">{{ constructedInfo.escrow_total | currency: 'USD':'symbol-narrow':'1.2-2' }}</div>
    </div>
    <div class="row">
      <div class="col-3 text-center"><h5>Expenses</h5></div>
      <div class="col-3 text-center"><h5>Expenses Paid</h5></div>
      <div class="col-3 text-center"><h5>Expenses Due</h5></div>
    </div>
    <div class="row">
      <div class="col-3 text-center">{{ constructedInfo.first_expense | currency: 'USD':'symbol-narrow':'1.2-2' }}</div>
      <div class="col-3 text-center">{{ constructedInfo.first_expense_payment | currency: 'USD':'symbol-narrow':'1.2-2' }}</div>
      <div class="col-3 text-center">{{ constructedInfo.first_expense_difference | currency: 'USD':'symbol-narrow':'1.2-2' }}</div>
    </div>
    <div class="row">
      <div class="col-3 text-center"><h5>Time</h5></div>
      <div class="col-3 text-center"><h5>Fixed Fee</h5></div>
      <div class="col-3 text-center"><h5>Other Charge</h5></div>
      <div class="col-3 text-center"><h5>Fees Due</h5></div>
    </div>
    <div class="row">
      <div class="col-3 text-center">{{ constructedInfo.time | currency: 'USD':'symbol-narrow':'1.2-2' }}</div>
      <div class="col-3 text-center">{{ constructedInfo.fixed_fee | currency: 'USD':'symbol-narrow':'1.2-2' }}</div>
      <div class="col-3 text-center">{{ constructedInfo.charge | currency: 'USD':'symbol-narrow':'1.2-2' }}</div>
      <div class="col-3 text-center">{{ constructedInfo.fee_due | currency: 'USD':'symbol-narrow':'1.2-2' }}</div>
    </div>
    <div class="my-3"></div>
    <div class="row">
      <div class="col-9 text-right">
        <h6>SUB TOTAL</h6>
      </div>
      <div class="col-3">
        {{ constructedInfo.sum_of_charges | currency: 'USD':'symbol-narrow':'1.2-2' }}
      </div>
    </div>
    <div class="row">
      <div class="col-9 text-right">
        <h6>FEE PAYMENTS</h6>
      </div>
      <div class="col-3">
        {{ constructedInfo.sum_of_payments | currency: 'USD':'symbol-narrow':'1.2-2' }}
      </div>
    </div>
    <div class="row">
      <div class="col-6 text-right">
        <h6>UNINVOICED BILLINGS</h6>
      </div>
      <div class="col-3">
        {{ constructedInfo.billings }}
      </div>
    </div>
    <div class="row">
      <div class="col-9 text-right">
        <h6>BALANCE DUE</h6>
      </div>
      <div class="col-3">
        {{ constructedInfo.balance | currency: 'USD':'symbol-narrow':'1.2-2' }}
      </div>
    </div>
  </div>
  <div class="my-3"></div>
  <div class="container-fluid container-shadow py-3 px-2">
    <div class="row">
      <div class="col-12 text-center"><h4>Fee Agreements</h4></div>
    </div>
    <div class="my-3"></div>
    <div class="row">
      <div class="col-12 text-center"><h5>Unsigned</h5></div>
    </div>
    <div class="row" *ngFor="let doc of matter_status_info.docs">
      <div class="col-2 ml-auto text-center" [tooltip]="doc.created_at_time" [title]="doc.created_at_time">{{ doc.created_at_date }}</div>
      <div class="col-2 mr-auto text-center">
        <a [href]="authService.getAuthenticatedDownloadUrl('/documents/' + doc.id + '/download')"> <img [src]="doc.document_image" />{{ doc.name }} </a>
      </div>
    </div>
    <div class="row">
      <div class="col-12 text-center" *ngIf="matter_status_info.docs.length < 1">No unsigned fee agreements found</div>
    </div>
    <div class="my-3"></div>
    <div class="row">
      <div class="col-12 text-center"><h5>Signed</h5></div>
    </div>
    <div class="row" *ngFor="let doc of matter_status_info.signed_docs">
      <div class="col-2 ml-auto text-center" [tooltip]="doc.created_at_time" [title]="doc.created_at_time">{{ doc.created_at_date }}</div>
      <div class="col-2 mr-auto text-center">
        <a [href]="authService.getAuthenticatedDownloadUrl('/documents/' + doc.id + '/download')"> <img [src]="doc.document_image" />{{ doc.name }} </a>
      </div>
    </div>
    <div class="row">
      <div class="col-12 text-center" *ngIf="matter_status_info.signed_docs.length < 1">No signed fee agreements found</div>
    </div>
    <div class="my-3"></div>
    <div class="row">
      <div class="col-12 text-center"><h5>Retainer</h5></div>
    </div>
    <div class="row">
      <div class="ml-auto col-2 text-center">The retainer is:&nbsp;</div>
      <div class="mr-auto col-2 text-center">{{ matter_status_info.retainerIsNaN ? matter_status_info.retainer : (matter_status_info.retainer | currency: 'USD':'symbol-narrow':'1.2-2') }}</div>
    </div>
  </div>
  <div class="my-3"></div>
  <div class="container-fluid container-shadow py-3 px-2">
    <div class="row">
      <div class="col-12 text-center"><h4>FUTURE EVENTS</h4></div>
    </div>
    <div class="my-3" *ngIf="matter_status_info.events.length > 0"></div>
    <div class="row" *ngIf="matter_status_info.events.length > 0">
      <div class="col-3 text-center"><h5>Start</h5></div>
      <div class="col-3 text-center"><h5>End</h5></div>
      <div class="col-3 text-center"><h5>Type</h5></div>
      <div class="col-3 text-center"><h5>Description</h5></div>
    </div>
    <div class="row" *ngFor="let event of matter_status_info.events">
      <div class="col-3 text-center">{{ event.start }}</div>
      <div class="col-3 text-center">{{ event.end }}</div>
      <div class="col-3 text-center">{{ event.event_type_name }}</div>
      <div class="col-3 text-center" [innerHTML]="event.notes | safeHtml"></div>
    </div>
    <div class="row" *ngIf="matter_status_info.events.length < 1">
      <div class="col-12 text-center">No events found</div>
    </div>
  </div>
  <div class="my-3"></div>
  <div class="container-fluid container-shadow py-3 px-2">
    <div class="row">
      <div class="col-12 text-center"><h4>RECENT HISTORIES</h4></div>
    </div>
    <div class="my-3"></div>
    <div class="row">
      <div class="col-12 text-center"><h5>Bookkeeping</h5></div>
    </div>
    <div class="row" *ngIf="matter_status_info.bookkeeping_matter_histories.length > 0">
      <div class="col-2 text-center"><h5>Date</h5></div>
      <div class="col-10 text-left"><h5>Message</h5></div>
    </div>
    <div class="row" *ngFor="let history of matter_status_info.bookkeeping_matter_histories">
      <div class="col-2 text-center" [tooltip]="history.created_at_time" [title]="history.created_at_time">{{ history.created_at_date }}</div>
      <div class="col-10 text-left" [innerHTML]="history.message | safeHtml"></div>
    </div>
    <div class="row">
      <div class="col-12 text-center" *ngIf="matter_status_info.bookkeeping_matter_histories.length < 1">No bookkeeping histories in the last month found</div>
    </div>
    <div class="my-3"></div>
    <div class="row">
      <div class="col-12 text-center"><h5>Manual</h5></div>
    </div>
    <div class="row" *ngIf="matter_status_info.manual_matter_histories.length > 0">
      <div class="col-2 text-center"><h5>Date</h5></div>
      <div class="col-10 text-left"><h5>Message</h5></div>
    </div>
    <div class="row" *ngFor="let history of matter_status_info.manual_matter_histories">
      <div class="col-2 text-center" [tooltip]="history.created_at_time" [title]="history.created_at_time">{{ history.created_at_date }}</div>
      <div class="col-10 text-left" [innerHTML]="history.message | safeHtml"></div>
    </div>
    <div class="row">
      <div class="col-12 text-center" *ngIf="matter_status_info.manual_matter_histories.length < 1">No manual histories in the last two months found</div>
    </div>
  </div>
  <div class="my-3"></div>
  <div class="container-fluid container-shadow py-3 px-2">
    <div class="row">
      <div class="col-12 text-center"><h4>Activity Rates</h4></div>
    </div>
    <div class="my-3"></div>
    <div class="row">
      <div class="col-3"></div>
      <div class="col-2"><h5>Name</h5></div>
      <div class="col-1"></div>
      <div class="col-1"><h5>Rate</h5></div>
      <div class="col-1"></div>
      <div class="col-3"><h5>Type</h5></div>
    </div>
    <div class="row mt-1" *ngFor="let activity_rate of matter_status_info.activity_rates">
      <div class="col-3"></div>
      <div class="col-2">{{ activity_rate.name }}</div>
      <div class="col-1"></div>
      <div class="col-1">{{ activity_rate.rate || 0 | currency: 'USD':'symbol-narrow':'1.2-2' }}</div>
      <div class="col-1"></div>
      <div class="col-3">
        <span *ngIf="activity_rate.is_hourly">H</span>
        <span *ngIf="activity_rate.is_flat_fee">F</span>
        <span *ngIf="activity_rate.is_percent">P</span>
      </div>
    </div>
  </div>
</div>
